import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const TermsAndConditionsPage = () => {
  return <CMSPage pageType="terms-and-conditions" />;
};

export default TermsAndConditionsPage;
